import React, { Component } from 'react';
import { toast } from 'react-toastify';

import CustomModal from "../../components/Modal/CustomModal";

import { DelFechaFer } from "../../funciones/PreferenciasAdminFunction";

class DiasFeriadosTable extends Component {
    state = {
        boton: {
            icon: "fa fa-trash",
            text: "Eliminar este registro"
        },
        modaldelBtn: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        openDel: false
    }

    modalDelete = () => {
        let { modaldelBtn, openDel } = this.state;
        let { datos } = this.props;

        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas eliminar la fecha <strong className="text-danger">{datos.dia}</strong> de la lista de Dias Feriados y no Laborables?</div>
                <div className="text-muted" style={{fontSize: 11}}>Esta opción no puede deshacerse</div>
            </React.Fragment>
        )

        let borrar = () => {
            if (modaldelBtn.disabled === true) return null;

            this.setState({
                modaldelBtn: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                DelFechaFer (datos.id, (resp) => {
                    this.setState({
                        modaldelBtn: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                        openDel: false
                    }, () => {
                        this.props.delResp();
                        toast.info("Se han eliminado el dia de la lista de Dias no Laborables",{autoClose: 4000});
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modaldelBtn.icon}></i> {modaldelBtn.text}</React.Fragment>}
                large = "medium"
                isopen =  {openDel}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Confirmación</div>}
                contenido = {contenidoModal()}      
                funcion1 = {borrar}
                funcion2 = {() => {this.setState({openDel: false})}}
            />
        );
    }

    render() {
        let { datos } = this.props;
        let { boton } = this.state;

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={{padding: 2, fontSize: 12}}>{datos.dia}</td>
                    <td width="70%" style={{padding: 2, fontSize: 10}}>{datos.motivo}</td>
                    <td width="70px" align="center" style={{padding: 2, fontSize: 10}}>
                        <button className="btn btn-danger" onClick={() => { this.setState({ openDel: true }) }} style={{borderWidth: 1}} title={boton.text}><i className={boton.icon}></i></button>
                    </td>
                </tr>
                {this.modalDelete()}
            </React.Fragment>
        );
    }
}
 
export default DiasFeriadosTable;


// WEBPACK FOOTER //
// ./src/views/Opciones/DiasFeriadosTable.jsx